import SosReportReadyPopup from "../SosReportReadyPopup"
import useSosReportReadyPopup from "../SosReportReadyPopup/connect"
import SosUpsellModal from "../SosUpsellModal"

/**
 * One auto-open dialog per visit (APP-487): the one-time report-ready popup
 * wins, and the recurring upsell modal stays suppressed for the rest of that
 * visit — dismissing the popup must not reveal a second dialog. The
 * suppression is per-visit, not per-company; a company switch reloads the
 * page (Main.handleCompanyChange), which resets it.
 */
export default function SosReportDialogs() {
  const { isOpen, wasOpenThisVisit, handleClose } = useSosReportReadyPopup()

  if (isOpen) {
    return <SosReportReadyPopup onClose={handleClose} />
  }

  return wasOpenThisVisit ? null : <SosUpsellModal />
}
